import React from 'react';
import { siteConfig } from '../../data/siteConfig';
interface BrandLogoProps {
  className?: string;
  /** When false, crops off the web address beneath the wordmark (for the slim header). */
  showUrl?: boolean;
}

/**
 * Supplied FINAL Logo.jpg. Its flat source background is RGB236/235/230.
 * The display filter lifts that background to white; multiply then blends it into
 * the page surface. The original artwork remains unchanged.
 */
export function BrandLogo({
  className = '',
  showUrl = false
}: BrandLogoProps) {
  return <span className={`relative block overflow-hidden ${className}`} style={{
    aspectRatio: showUrl ? '462 / 264' : '462 / 190'
  }} data-id="element-294" data-mp="15hb8hayxsq2t">
      <img src={siteConfig.logoUrl} alt={siteConfig.brandName} className="absolute inset-x-0 top-0 w-full brightness-[1.14] mix-blend-multiply" data-id="element-295" data-mp="vjdl0powixb9" />
    </span>;
}